<template>
  <div class="materia-items" id="materia-items">
    <div class="btns-box">
      <div
          v-if="['image','audio','video'].includes(type) && newIsAdd"
          class="item-btn item add"
          @click="handleClickAddBatch"
      >
        <!--<span class="iconAdd">+</span>-->
        <span class="word">批量上传</span>
      </div>
      <div
          v-if="newIsAdd && isShow"
          class="item-btn item add"
          @click="handleAdd"
      >
        <!--<span class="iconAdd">+</span>-->
        <span class="word">上传</span>
      </div>
    </div>
    <div
      v-for="(item, index) in data"
      class="item-btn item"
      :class="{template: ['template'].includes(type)}"
      :key="index"
      @click="handleSelect(item)"
    >
      <VideoItem
          v-if="type==='video' && item.url"
          :index.sync="index"
          :url.sync="item.url"
          @onBackground="$emit('onBackground', item, 'backgroundVideo')"
      />
      <TemplateItem
              v-else-if="type==='template'"
              theme="light"
              :item.sync="item"
              @onSelect="handleSelect(item)"
      />
      <CompImgBox
          v-else
          :is-tilte="true"
          :item="item"
          :isBackground="type==='image'"
          @onBackground="handleSetBackground(item)"
          @onSelect="handleSelect(item)"
      />

    </div>
    <div
        v-if="pageConfig.total>pageConfig.pageSize"
        class="footer-box-more"
    >
      <el-pagination
        v-if="data && data.length>0"
        :small="true"
        background
        layout="prev, pager, next"
        v-bind="newPageConfig"
        @current-change="currentChange"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import { Loading } from "element-ui";
import VideoItem from '../../../../views/main/components/types/components/common/components/typeList/components/video'
import TemplateItem from '../../../../views/main/components/types/components/common/components/typeList/components/template'
export default {
  name: "material-item",
  components: {
    VideoItem,
    TemplateItem
  },
  props: {
    isShop: {
      type: Boolean,
      default: false
    },
    isAdd: {
      type: Boolean,
      default: false
    },
    isShow:{
      type:Boolean,
      default:true
    },
    type: String,
    categoryId: [String, Number],
    data: [Array,Object],
    loading: {
      type: Boolean,
      default: false
    },
    pageConfig: {
      type: Object,
      default: ()=>{
        return {
          page: 1,
          pageSize: 18,
          total: 1
        }
      }
    }
  },
  computed:{
    // 当前类型是否和当前校区类型一致
    curTypeEqualCurUser(){
      return this.isShop === this.$store.getters.isPlat
    },
  },
  watch: {
    isAdd(vl){this.newIsAdd = vl},
    newIsAdd(vl){this.$emit('update:isAdd',vl)},
    pageConfig(vl){this.newPageConfig = vl},
    newPageConfig(vl){this.$emit('update:pageConfig',vl)},
    loading: {
      handler(vl) {
        if (vl) {
          this.element = Loading.service({
            target: document.getElementById("materia-items")
          });
        } else {
          this.element && this.element.close();
        }
      },
      deep: true,
      immediate: true
    }
  },
  data() {
    return {
      newIsAdd: this.isAdd,
      element: null,
      newPageConfig: this.pageConfig
    };
  },
  methods: {
    onUpload(item) {
      console.log("上传资源==>", item);
      this.$emit("onUpload", item);
    },
    handleSelect(item) {
      console.log("立即使用==>", item);
      this.$emit("onMaterialItem", item);
    },
    handleSetBackground(item){
      console.log("设置为背景图==>", item);
      this.$emit("onMaterialItem", item, 'background');
    },
    currentChange(curPage) {
      console.log("获取当前分页", curPage);
      this.$emit('onPage', curPage)
    },
    handleAdd() {
      if(!this.curTypeEqualCurUser){
        this.$emit('onChanageTab', 'handleAdd')
        return false
      }
      this.$emit('onMaterialItemAdd')
    },
    // 批量上传
    handleClickAddBatch () {
      if(!this.curTypeEqualCurUser){
        this.$emit('onChanageTab', 'handleClickAddBatch')
        return false
      }
      this.$emit('batchAdd')
    }
  }
};
</script>
<style>
.footer-box-more
  .el-pagination.is-background
  .el-pager
  li:not(.disabled).active {
  background-color: #e7622e;
}
.footer-box-more
  .el-pagination.is-background
  .el-pager
  li:not(.disabled).active:hover {
  color: white;
}
.footer-box-more
  .el-pagination.is-background
  .el-pager
  li:not(.disabled):hover {
  color: #fed800;
}
</style>
<style lang="scss" scoped>
.materia-items {
  display: flex;
  flex: 1;
  flex-direction: row;
  flex-wrap: wrap;
  position: relative;
  /*border-left: 1px solid #f1f1f1;*/
  /*margin-left: 10px;*/
  padding-bottom: 10px;
  align-content: flex-start;

  .btns-box {
    position: absolute;
    top: -61px;
    left: 468px;
    display: flex;
    flex-direction: row;
    align-items: center;

    .add{
      height: 30px;
      width: initial;
      padding: 0px 13px;
      margin-left: 16px;

      .word{
        margin-left: 0px !important;
      }
    }

    .item-btn {
      cursor: pointer;

      &.add {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;

        .iconAdd {
          color: #303133;
          font-size: 20px;
          width: 26px;
          height: 26px;
          line-height: 22px;
          background: rgba(240, 242, 245, 1);
          border-radius: 50%;
          text-align: center;
          cursor: pointer;
        }

        .word {
          font-size: 14px;
          font-weight: 500;
          color: rgba(48, 49, 51, 1);
          line-height: 20px;
          margin-left: 6px;
          cursor: pointer;
        }
      }

      .img-box {
        display: flex;
        flex-direction: row;
        width: 100%;
        height: 100%;
        justify-content: center;

        .img {
          width: auto;
          height: auto;
        }
      }
    }
  }

  .item {
    width: 124px;
    margin-left: 20px;
    margin-top: 20px;
    position: relative;

    /*box-shadow: 0px 0px 2px 0px rgba(0, 0, 0, 0.1);*/
    border-radius: 4px;
    border: 1px solid #DCDFE6;

    &.template{
      width: 46%;
    }

    .img {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }


    .set-bg{
      position: absolute;
      top: 6px;
      left: 8px;
      font-size: 12px;
      /*border: 1px solid #eee;*/
      background-color: rgba(255, 255, 255, 0.8);
      border-radius: 12px;
      padding: 2px 4px;
      color: #303133;
      transition: all .2s linear;

      &:hover{
        background-color: #e7622e;
      }
      &:active{
        opacity: .8;
        top: 6px;
      }
    }
    .txt-box {
      position: absolute;
      width: 100%;
      /*height: 100%;*/
      bottom: 0px;
      left: 0px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;

      .name{
        background:rgba(0,0,0,0.25);
        font-size: 12px;
        padding: 4px;
        color:rgba(255,255,255,0.85);
      }

      .eyes-box {
        display: flex;
        flex-direction: row;
        justify-content: flex-end;
        padding-top: 10px;
        padding-right: 10px;

        .kejian {
          width: 18px;
          height: 11px;
        }
        .bukejian {
          width: 16px;
          height: 14px;
        }
      }
      .btns {
        display: flex;
        flex-direction: row;
        justify-content: center;

        .btn {
          font-size: 12px;
          color: white;
          padding: 2px 12px;
          background-color: #e7622e;
          border-radius: 20px;
          margin: 10px 0px;
          cursor: pointer;
        }
      }
    }
  }

  .footer-box-more {
    display: flex;
    width: 100%;
    justify-content: center;
    align-items: center;
    margin-top: 20px;
    margin-bottom: 30px;
  }
}
</style>
